import { useParams, Navigate } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { LEGAL_PAGES, LEGAL_KEYS } from "../i18n/legalContent";
import Reveal from "../components/Reveal";

export default function LegalPage() {
  const { page } = useParams();
  const { lang } = useLanguage();

  if (!LEGAL_KEYS.includes(page)) return <Navigate to="/" replace />;

  const doc = LEGAL_PAGES[page][lang] || LEGAL_PAGES[page].en;

  return (
    <div data-testid={`legal-${page}`} className="min-h-screen bg-white pt-24">
      <div className="mx-auto max-w-3xl px-6 pb-24">
        <Reveal>
          <h1 className="font-display text-5xl font-light tracking-tight text-navy">{doc.title}</h1>
          <p className="mt-4 text-xs uppercase tracking-[0.2em] text-gold-dark">{doc.updated}</p>
        </Reveal>
        <div className="mt-14 space-y-10">
          {doc.sections.map((s) => (
            <Reveal key={s.h}>
              <section data-testid={`legal-section-${s.h.slice(0, 12)}`}>
                <h2 className="font-display text-2xl font-light text-navy">{s.h}</h2>
                <p className="mt-3 text-sm font-light leading-relaxed text-navy/65">{s.body}</p>
              </section>
            </Reveal>
          ))}
        </div>
        <Reveal>
          <p className="mt-16 border-t border-navy/10 pt-8 text-xs text-navy/45">
            Antalia Pharma · 30 Agias Irinis Str., Marousi 15126, Athens · info@antalia-pharma.com
          </p>
        </Reveal>
      </div>
    </div>
  );
}
